import React from "react";
import { Body2, Checkbox } from "@activecollab/components";
import classNames from "classnames";
import PropTypes from "prop-types";

export const ViewSettingsListItem = ({ id, label, value, onChange, Icon, iconClassName, className }) => {
  return (
    <div
      className={classNames(
        "tw-flex tw-flex-row tw-items-center tw-justify-between tw-h-8 tw-min-h-[32px] tw-px-2 tw-rounded",
        className
      )}
    >
      <div className="tw-flex tw-flex-row tw-items-center">
        {Icon ? (
          <Icon
            width={16}
            height={16}
            className={classNames("tw-shrink-0 tw-mr-2", iconClassName)}
          />
        ) : null}
        <Body2>{label}</Body2>
      </div>
      <Checkbox
        id={id}
        onChange={onChange}
        checked={value}
      />
    </div>
  );
};

ViewSettingsListItem.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  Icon: PropTypes.object,
  value: PropTypes.bool,
  onChange: PropTypes.func,
  iconClassName: PropTypes.string,
  className: PropTypes.string,
};

ViewSettingsListItem.defaultProps = {
  value: false,
};
